<template>
  <div>
    <div :class="$style.header">
      <template>
        <el-button v-if="templateType === 'info'" class="is-round isStyleBase" @click="backInventoryManagement">
          <BaseIcon name="arrow-left" />
          返回
        </el-button>

        <el-button v-else class="is-round isStyleBase" @click="goInfo">
          <BaseIcon name="arrow-left" />
          返回{{ purchaseText }}單
        </el-button>
        <h3>選擇{{ purchaseText }}商品</h3>
      </template>
    </div>

    <PurchaseInformation v-if="templateType === 'info'" :product-list="productList" :purchase-type="purchaseType"
      @goCategory="goCategory" @goInventoryManagement="$emit('showInventoryManagement')" @selectedShippingPoint="selectedShippingPoint"> </PurchaseInformation>

    <PurchaseCategory v-if="templateType === 'category'" :purchase-text="purchaseText" :category-type="categoryType"
      :current-list="currentList" :product-list="productList" @resetCategory="resetCategory"
      @goNextCategory="goNextCategory" @goDetail="goDetail" @goInfo="templateType = 'info'"
      @backToCategoryType="backToCategoryType">
    </PurchaseCategory>

    <InventoryItemDetail v-if="templateType === 'detail'" :user-selected-shipping-point="userSelectedShippingPoint" :inventory-item-detail-data="inventoryItemDetailData"
      @goCategory="templateType = 'category'"></InventoryItemDetail>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import lazyLoadComponent from '@router/lazyload-component'
export default {
  name: 'PurchasePage',
  components: {
    PurchaseInformation: () => lazyLoadComponent(import('./components/PurchaseInformation.vue')),
    PurchaseCategory: () => lazyLoadComponent(import('./components/PurchaseCategory.vue')),
    InventoryItemDetail: () => lazyLoadComponent(import('./components/InventoryItemDetail.vue')),
  },
  props: {
    purchaseType: {
      type: String,
      default: 'purchase',
    },
  },
  data() {
    return {
      templateType: 'info', // info, category, detail
      categoryType: 'category', // category, product
      categoryList: [],
      cloneCategoryList: [], // 類別有機會復原，所以先存著就不用打api了
      currentList: [],
      productList: [],
      inventoryItemDetailData: {}, // 商品的詳細規格列表
      userSelectedShippingPoint: '', // 使用者選到的出貨進貨點
    }
  },
  computed: {
    purchaseText() {
      return this.purchaseType === 'purchase' ? '進貨' : '退貨'
    },
  },
  mounted() {
    this.getCategoryList()
  },
  methods: {
    selectedShippingPoint(val){
      this.userSelectedShippingPoint = val
    },
    async getCategoryList() {
      this.categoryList = await this.$store.dispatch('product/fetchServiceCategoryForLeaf', {
        type: 'goods',
        onlyLeaf: 0,
      })
      this.cloneCategoryList = cloneDeep(this.categoryList)
      this.currentList = this.categoryList
    },
    /**
     * @description 類別復原
     */
    resetCategory() {
      this.currentList = cloneDeep(this.cloneCategoryList)
      this.categoryType = 'category'
    },
    async getProductList(id) {
      try {
        let res = await this.$store.dispatch('product/fetchNormalServiceData', {
          types: ['goods'],
          petCategoryId: id,
        })
        res.items.forEach(item => {
          item.petSizes.forEach(petItem => {
            this.$set(petItem, 'petCategory', item.petCategoryTitle)
            this.$set(petItem, 'serviceTitle', item.title)
          })
        })

        this.productList = res.items
      } catch (error) {
        console.error(error.message)
      }
    },
    goInfo() {
      this.templateType = 'info'
      this.categoryType = 'category'
      this.currentList = this.categoryList
    },
    /**
     * @description 增加完商品之後，商品要返回成原本面板
     */
    backToCategoryType() {
      this.goInfo()
    },
    goCategory() {
      this.templateType = 'category'
    },
    /**
     * @description 前往下一個類別
     */
    async goNextCategory(category, itemsList) {
      // null 代表使用者search -> 直接跳product
      if (!category) {
        this.categoryType = 'product'
        this.productList = itemsList
        return
      }
      if (this.isLastCategory(category)) {
        // 如果是最後一層，就來這邊找商品清單
        this.getProductList(category.id)
        this.categoryType = 'product'
      } else {
        this.currentList = category.children
      }
    },
    goDetail(itemDetailIndex) {
      this.inventoryItemDetailData = this.productList[itemDetailIndex]
      this.templateType = 'detail'
    },
    /**
     * @description 看是不是最後一層的分類
     */
    isLastCategory(category) {
      return category.children.length === 0
    },
    backInventoryManagement() {
      window.localStorage.removeItem('tempInfo')
      this.$emit('showInventoryManagement')
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.table {
  @include layer-elevation(5);

  :global {
    tr.el-table__row.expanded {
      background-color: #f2f2f2;

      td:first-child {
        border-left: #c0975d 4px solid;
      }
    }
  }
}

.header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;

  :global {
    .el-button {
      margin-right: 20px;
    }
  }
}
</style>
